import { useState } from 'react'
import PromoCode from './PromoCode'
import EditPromoCodeModal from 'pages/Admin/Modals/EditPromoCodeModal'
import PromoCodeMembersModal from 'pages/Admin/Modals/PromoCodeMembersModal'

import {
  Container,
  SubTitle,
  LabelRow
} from './styles'

export default function PromoCodeList ({
  promoCodes = [],
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  const [promoCodeData, setPromoCodeData] = useState (null)
  const [showMembersModal, setShowMembersModal] = useState (false)
  const [showEditPromoCodeModal, setShowEditPromoCodeModal] = useState (false)

  const showMembers = promoCode => {
    setPromoCodeData (promoCode)
    toggleMembersModal ()
  }
  
  const editPromoCode = promoCode => {
    setPromoCodeData (promoCode)
    toggleEditPromoCodeModal ()
  }

  const toggleMembersModal = () => setShowMembersModal (!showMembersModal)
  const toggleEditPromoCodeModal = () => setShowEditPromoCodeModal (!showEditPromoCodeModal)

  return (
    <Container>
      <SubTitle>
        {promoCodes.length + ' ' + (promoCodes.length === 1 ? 'Resultado' : 'Resultados')}
      </SubTitle>
      <LabelRow>
        <SubTitle>Código</SubTitle>
        <SubTitle>Qtd. total</SubTitle>
        <SubTitle>Qtd. disponível</SubTitle>
        <SubTitle>Validade</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {promoCodes.map (promoCode => (
        <PromoCode
          key={promoCode.id}
          data={promoCode}
          onShowMembers={showMembers}
          onEdit={editPromoCode}
          onDelete={handleDelete}
        />
      ))}
      {!!promoCodeData && (
        <>
          <EditPromoCodeModal
            visible={showEditPromoCodeModal}
            data={promoCodeData}
            onClose={toggleEditPromoCodeModal}
            onConfirm={handleEdit}
          />
          <PromoCodeMembersModal
            visible={showMembersModal}
            promoCode={promoCodeData}
            onClose={toggleMembersModal}
          />
        </>
      )}
    </Container>
  )
}
